import debounce from 'just-debounce';

import Forms from '../Forms';

import { numberInputValidation, getLiquidVars } from '#helpers';

export default class StaticAgeGate {
  constructor(section) {
    this.$el = $(section.el);

    // If the age gate doesn't exist (instore tablet)
    // do not proceed
    if (!this.$el.length) {
      return false;
    }

    this.$body = $('body');
    this.$window = $(window);

    this.siteData = getLiquidVars('[data-site-data]');
    this.restrictedAge = this.siteData.age;
    this.isUnrestricted = this.siteData.is_unrestricted;

    this.storage = window.sessionStorage;
    this.keys = {
      verified: 'isVerified',
      unverified: 'isUnverified'
    };

    // Age gate elements
    this.$ageGate = this.$el.find('[data-age-gate]');
    this.$ageGateForm = this.$ageGate.find('[data-age-gate-form]');
    this.$ageGateButton = this.$ageGate.find('[data-age-gate-button]');
    this.$ageGateMessage = this.$ageGate.find('[data-age-gate-message]');
    this.$ageGateSeparator = this.$ageGate.find('.age-gate--separator');

    // Unverified elements
    this.$siteHeader = $('[data-site-header-main]');
    this.$ageGateHeaderMessage = this.$siteHeader.find(
      '[data-header-age-gate-message]'
    );
    this.$ageGateLink = this.$siteHeader.find('[data-header-age-gate-open]');
    this.$headerLoginLink = this.$siteHeader.find('.site-header-account--link');

    // Menus
    this.$restrictedMainMenu = $('[data-navmenu-mainmenu]');
    this.$restrictedFooterMenus = $('[data-footer-restricted-menu]');
    this.$unrestrictedMainMenu = $('[data-navmenu-unrestricted-menu]');
    this.$unrestrictedFooterMenus = $('[data-footer-unrestricted-menu]');

    if (this.$ageGateForm.length) {
      new Forms(this.$ageGateForm);
    }

    // Age gate functions
    this._ageGateCheck = this._ageGateCheck.bind(this);
    this._ageVerified = this._ageVerified.bind(this);
    this._ageUnverified = this._ageUnverified.bind(this);
    this._addUnverifiedDataAttr();

    this.events = [
      // Date form events (use input and keydown to cover pasting values)
      this.$ageGateForm.on(
        'input keydown',
        '[data-age-gate-field]',
        this._validateInput.bind(this)
      ),
      // Verified events
      this.$ageGateForm.on('keyup', this._ageGateCheck),
      this.$ageGateForm.on('change', this._ageGateCheck),
      this.$ageGateForm.on('submit', this._ageVerified),
      // Unverified events
      this.$ageGate.on(
        'click',
        '[data-age-gate-unverified]',
        this._ageUnverified
      ),
      this.$window.on('load', this._checkUnverified.bind(this)),
      this.$ageGateLink.on('click', this._resetAgeGate.bind(this)),
      // Inactivity events
      $(document).on(
        'mousemove',
        debounce(() => this._resetInactivityTimer(), 100)
      ),
      $(document).on(
        'keydown',
        debounce(() => this._resetInactivityTimer(), 100)
      ),
      $(document).on(
        'touchstart',
        debounce(() => this._resetInactivityTimer(), 100)
      )
    ];

    // Hide age gate until section is selected in theme editor
    // (see bottom of file for section functions)
    if (window.Shopify && window.Shopify.designMode) {
      this.$body.removeClass('ag--hc scroll-lock');
      this.$ageGate.removeClass('visible');
    } else {
      // Check for verified/unverified session storage items
      this._checkVerified();
      this._resetInactivityTimer();
    }
  }

  _addUnverifiedDataAttr() {
    this.$ageGate.find('a').each((i, el) => {
      $(el).attr('data-age-gate-unverified', '');
    });
  }

  _validateInput(event) {
    const target = event.target;
    const validateLength = target.maxLength;

    // Limit input to validation length
    if (target.value.length > validateLength) {
      target.value = target.value.substring(0, validateLength);
    }

    return numberInputValidation(event);
  }

  _resetInactivityTimer() {
    if (
      this.storage.getItem(this.keys.verified) ||
      this.storage.getItem(this.keys.unverified)
    ) {
      if (this.inactivityTimeout) {
        clearTimeout(this.inactivityTimeout);
      }
      this.inactivityTimeout = setTimeout(
        this._resetAgeGate.bind(this),
        1000 * 60 * 60
      );
    }
  }

  _ageUnverified() {
    // Add session storage item that will clear when site is navigated away from
    this.storage.setItem(this.keys.unverified, true);
  }

  _checkUnverified() {
    if (this.storage.getItem(this.keys.unverified) && this.isUnrestricted) {
      // Age unverified, remove restricted header and footer menus
      this.$restrictedMainMenu.remove();
      this.$restrictedFooterMenus.remove();

      // Remove hide content and scroll lock classes from body only if unverified
      // Needed to hide flash of menus and other items hiding and showing
      this.$body.removeClass('ag--hc scroll-lock');
      this.$ageGateLink.addClass('visible');
      this.$ageGateHeaderMessage.addClass('visible');
      this.$headerLoginLink.addClass('button');
      this.$body.addClass('ag--uv');
    } else {
      // Age verified, remove unrestricted header and footer menus
      this.$unrestrictedMainMenu.remove();
      this.$unrestrictedFooterMenus.remove();
    }
  }

  _checkVerified() {
    // Hide age gate if verified or unverified session storage item exists
    const verified = this.storage.getItem(this.keys.verified);

    if (
      verified ||
      (this.storage.getItem(this.keys.unverified) && this.isUnrestricted)
    ) {
      this.$ageGate.revealer('hide');

      // Remove hide content and scroll lock classes from body only if verified
      if (this.storage.getItem(this.keys.verified)) {
        this.$body.removeClass('ag--hc scroll-lock');
      }
    } else {
      this._resetAgeGate();
    }
  }

  _resetAgeGate() {
    this.$body.removeClass('ag--uv').addClass('ag--hc scroll-lock');
    this.$ageGate.revealer('show');
    this.$ageGateLink.removeClass('visible');
    this.$ageGateHeaderMessage.removeClass('visible');
    this.$headerLoginLink.removeClass('button');

    this.storage.removeItem(this.keys.unverified);
    this.storage.removeItem(this.keys.verified);
  }

  // Check if all fields have a value
  _ageGateCheck() {
    const yearVal = parseInt(
      this.$ageGateForm.find('#age_gate_year').val(),
      10
    );
    const monthVal = parseInt(
      this.$ageGateForm.find('#age_gate_month').val(),
      10
    );
    const dayVal = parseInt(this.$ageGateForm.find('#age_gate_day').val(), 10);

    if (this._ageGateDateIsValid(yearVal, monthVal, dayVal)) {
      this._checkAge(monthVal, dayVal, yearVal);
    } else {
      this._disableSubmitButton();
    }
  }

  _ageGateDateIsValid(year, month, day) {
    // If year, month, and day have no value, return false
    if (!(year && month && day)) {
      return false;
    }

    // If year, month, and day have values, return false if below min and maxes
    const yearInt = year;
    const monthInt = month;
    const dayInt = day;
    if (yearInt <= 1898) {
      return false;
    }
    if (monthInt < 1 || monthInt > 12) {
      return false;
    }

    // If year, month, and day have values, check date to get days in the month to validate
    const daysInMonth = new Date(yearInt, monthInt, 0).getUTCDate();
    if (dayInt < 1 || dayInt > daysInMonth) {
      return false;
    }
    return true;
  }

  // Create session storage item and dismiss age gate
  _checkAge(birthMonth, birthDay, birthYear) {
    const today = new Date();
    const theirDate = new Date(
      birthYear + this.restrictedAge,
      birthMonth - 1,
      birthDay
    );

    // If adult, enable enter button. If date changes, disable button again
    if (today.getTime() - theirDate.getTime() < 0) {
      this._disableSubmitButton();
      this.$ageGateMessage.addClass('visible');
      this.$ageGateSeparator.addClass('message-visible');
    } else {
      this._enableSubmitButton();
      this.$ageGateMessage.removeClass('visible');
      this.$ageGateSeparator.removeClass('message-visible');
    }
  }

  _ageVerified(event) {
    event.preventDefault();

    // Add session storage item that will clear when site is navigated away from
    this.storage.setItem(this.keys.verified, true);

    // Reload page after verifying age
    location.reload(true);
  }

  _enableSubmitButton() {
    this.$ageGateButton.removeClass('disabled').removeAttr('disabled');
  }

  _disableSubmitButton() {
    this.$ageGateButton.addClass('disabled').attr('disabled', true);
  }

  onSectionUnload() {
    this.$el.off('.age-gate');
    this.forms.unload();
  }

  // Show age gate if selected in theme editor
  onSectionSelect() {
    this.$ageGate.addClass('visible');
  }

  // Hide age gate if deselected in theme editor
  onSectionDeselect() {
    this.$ageGate.removeClass('visible');
  }
}
